(function () {
  function syncNode(node) {
    var hidden = node.getAttribute('aria-hidden') === 'true';
    var focusable = node.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');
    focusable.forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-a11y-orig-tabindex')) {
          el.setAttribute('data-a11y-orig-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-orig-tabindex')) {
        var orig = el.getAttribute('data-a11y-orig-tabindex');
        if (orig) { el.setAttribute('tabindex', orig); } else { el.removeAttribute('tabindex'); }
        el.removeAttribute('data-a11y-orig-tabindex');
      }
    });
  }

  function scanAll(root) {
    (root || document).querySelectorAll('[aria-hidden]').forEach(syncNode);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanAll();

    var attrObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          syncNode(m.target);
        }
      });
    });
    attrObserver.observe(document.body, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });

    var addObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) { return; }
          if (node.hasAttribute && node.hasAttribute('aria-hidden')) { syncNode(node); }
          if (node.querySelectorAll) { scanAll(node); }
        });
      });
    });
    addObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
